import produce from 'immer'
import { CardspressAction, CardspressActionTypes } from '../actions/cardspressActions'
import { ApiStatus, ICardspressItem } from '../models'

export const initialCardspressState: ICardspressState = {
  loadingStatus: ApiStatus.NOTLOADED,
  addingStatus: ApiStatus.NOTLOADED,
  searchingStatus: ApiStatus.NOTLOADED,
  searchString: '',
  cardspress: [],
  foundcardspress: [],
  totalDocs: 0,
  errMessage: '',
  errStatus: null,
  errField: null,
}

export default function cardspressReducer(state: ICardspressState = initialCardspressState, action: CardspressAction) {
  return produce(state, (draft) => {
    switch (action.type) {
      case CardspressActionTypes.SEARCH_CARDSPRESS:
        draft.searchString = action.searchOptions.searchString
        break
      case CardspressActionTypes.SEARCHING_CARDSPRESS:
        draft.searchingStatus = ApiStatus.LOADING
        draft.loadingStatus = ApiStatus.NOTLOADED
        draft.addingStatus = ApiStatus.NOTLOADED
        break

      case CardspressActionTypes.SEARCHING_CARDSPRESS_FAILED:
        draft.searchingStatus = ApiStatus.FAILED
        break

      case CardspressActionTypes.FOUND_CARDSPRESS:
        draft.searchingStatus = ApiStatus.LOADED
        action.keep ? draft.foundcardspress.push(...action.payload.cardspress.docs) : (draft.foundcardspress = action.payload.cardspress.docs)
        draft.totalDocs = action.payload.cardspress.totalDocs
        break

      case CardspressActionTypes.LOAD_CARDSPRESS:
      case CardspressActionTypes.LOADING_CARDSPRESS:
        draft.loadingStatus = ApiStatus.LOADING
        draft.addingStatus = ApiStatus.NOTLOADED
        draft.searchingStatus = ApiStatus.NOTLOADED
        draft.foundcardspress = []
        break

      case CardspressActionTypes.LOADING_CARDSPRESS_FAILED:
        draft.loadingStatus = ApiStatus.FAILED
        break

      case CardspressActionTypes.LOADED_CARDSPRESS:
        draft.loadingStatus = ApiStatus.LOADED
        draft.cardspress = action.payload.cardspress.docs
        draft.totalDocs = action.payload.cardspress.totalDocs
        break

      case CardspressActionTypes.ADD_CARDSPRESS:
      case CardspressActionTypes.ADDING_CARDSPRESS:
        draft.addingStatus = ApiStatus.LOADING
        draft.searchingStatus = ApiStatus.NOTLOADED
        draft.errMessage = ''
        draft.errStatus = null
        draft.errField = null
        break

      case CardspressActionTypes.ADDING_CARDSPRESS_FAILED:
        draft.addingStatus = ApiStatus.FAILED
        draft.errMessage = action.message
        draft.errStatus = action.status
        draft.errField = action.field
        break

      case CardspressActionTypes.ADDED_CARDSPRESS:
        draft.addingStatus = ApiStatus.LOADED
        draft.errStatus = 200
        draft.cardspress.push(action.payload.cardspress.docs[0])
        if (draft.searchString) draft.foundcardspress.push(action.payload.cardspress.docs[0])
        break

      case CardspressActionTypes.REMOVE_CARDPRESS:
        draft.cardspress.splice(
          draft.cardspress.findIndex((cardpress) => cardpress._id === action.payload._id),
          1
        )
        break

      case CardspressActionTypes.SOFT_REMOVE_CARDSPRESS:
        draft.loadingStatus = ApiStatus.NOTLOADED
        draft.addingStatus = ApiStatus.LOADING
        break

      case CardspressActionTypes.SOFT_REMOVING_CARDSPRESS:
        draft.loadingStatus = ApiStatus.LOADING
        draft.addingStatus = ApiStatus.LOADING
        break

      case CardspressActionTypes.SOFT_REMOVED_CARDSPRESS:
        draft.addingStatus = ApiStatus.LOADED
        draft.cardspress.splice(
          draft.cardspress.findIndex((cardpress) => cardpress._id === action.payload._id),
          1
        )
        break

      case CardspressActionTypes.SOFT_REMOVING_CARDSPRESS_FAILED:
        draft.addingStatus = ApiStatus.FAILED
        draft.errMessage = action.message
        draft.errStatus = action.status
        draft.errField = action.field
        break

      case CardspressActionTypes.EDIT_CARDSPRESS:
        draft.loadingStatus = ApiStatus.NOTLOADED
        draft.addingStatus = ApiStatus.LOADING
        draft.searchingStatus = ApiStatus.NOTLOADED
        break

      case CardspressActionTypes.EDITING_CARDSPRESS:
        draft.loadingStatus = ApiStatus.LOADING
        draft.addingStatus = ApiStatus.LOADING
        break

      case CardspressActionTypes.EDITED_CARDSPRESS:
        draft.addingStatus = ApiStatus.LOADED
        draft.cardspress[draft.cardspress.findIndex((cardpress) => cardpress._id === action.payload._id)] = action.payload
        draft.foundcardspress[draft.foundcardspress.findIndex((cardpress) => cardpress._id === action.payload._id)] = action.payload
        break

      case CardspressActionTypes.EDITING_CARDSPRESS_FAILED:
        draft.addingStatus = ApiStatus.FAILED
        draft.errMessage = action.message
        draft.errStatus = action.status
        draft.errField = action.field
        break
    }
  })
}

export interface ICardspressState {
  loadingStatus: ApiStatus
  addingStatus: ApiStatus
  searchingStatus: ApiStatus
  searchString: string
  cardspress: ICardspressItem[]
  foundcardspress: ICardspressItem[]
  totalDocs: number
  errMessage?: string
  errStatus?: number
  errField?: string
}
